import React from "react";
import { ResponsiveModal } from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Stack } from "@UI/Components/Stack/Stack";
import { Button } from "@UI/Components/Button/Button";
import messages from "./messages";
import { Link } from "@UI/Components/Link/Link";

interface Props {
  isOpen: boolean;
  profileUrl?: string;
  onClose: () => void;
  isMobile: boolean;
  type: string;
}

export const QuestionModal = ({
  isOpen,
  profileUrl,
  onClose,
  isMobile,
  type,
}: Props) => {
  const typeContent = {
    share_profile: {
      title: <FormattedMessage {...messages.share_profile_title} />,
      subtitle: <FormattedMessage {...messages.share_profile_core} />,
    },
    respect_rules: {
      title: <FormattedMessage {...messages.respect_rules_title} />,
      subtitle: <FormattedMessage {...messages.respect_rules_core} />,
    },
    how_to_super: {
      title: <FormattedMessage {...messages.how_to_super} />,
      subtitle: <FormattedMessage {...messages.how_to_core} />,
    },
    do_jobs: {
      title: <FormattedMessage {...messages.do_jobs_title} />,
      subtitle: <FormattedMessage {...messages.do_jobs_core} />,
    },
    ask_questions: {
      title: <FormattedMessage {...messages.ask_questions_title} />,
      subtitle: <FormattedMessage {...messages.ask_questions_core} />,
    },
    discover_advice: {
      title: <FormattedMessage {...messages.discover_advice_title} />,
      subtitle: <FormattedMessage {...messages.discover_advice_core} />,
    },
    finish_jobs: {
      title: <FormattedMessage {...messages.finish_jobs_title} />,
      subtitle: <FormattedMessage {...messages.finish_jobs_core} />,
    },
    current_jobs_questions: {
      title: <FormattedMessage {...messages.current_jobs_questions_title} />,
      subtitle: <FormattedMessage {...messages.current_jobs_questions_core} />,
    },
    work_previous_clients: {
      title: <FormattedMessage {...messages.work_previous_clients_title} />,
      subtitle: <FormattedMessage {...messages.work_previous_clients_core} />,
    },
    quality_offers: {
      title: <FormattedMessage {...messages.quality_offers_title} />,
      subtitle: <FormattedMessage {...messages.quality_offers_core} />,
    },
    follow_feedback: {
      title: <FormattedMessage {...messages.follow_feedback_title} />,
      subtitle: <FormattedMessage {...messages.follow_feedback_core} />,
    },
    be_patient: {
      title: <FormattedMessage {...messages.be_patient_title} />,
      subtitle: <FormattedMessage {...messages.be_patient_core} />,
    },
  };

  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={onClose}
      isCentered={!isMobile}
      size={{ base: "sm", md: "lg" }}
    >
      <Stack spacing={4} pb={6}>
        <Heading
          as="h3"
          marginRight="3"
          fontSize={{ base: "2xl", lg: "4xl" }}
        >
          {typeContent[type]?.title}
        </Heading>
        <Text fontSize="md">{typeContent[type]?.subtitle}</Text>
        {type === "share_profile" && profileUrl && (
          <Link as="a" href={profileUrl}>
            <Button colorScheme="seaGreen" size="lg" width="full">
              <FormattedMessage {...messages.share_my_profile} />
            </Button>
          </Link>
        )}
      </Stack>
    </ResponsiveModal>
  );
};
